import { CSSProperties, ReactNode } from 'react';

interface InputSwitchProps {
    value: boolean,
    label: ReactNode,
    disabled?: boolean,
    onChange?: (value: boolean) => void,
    style?: CSSProperties
}

export function InputSwitch({ value, label, disabled, onChange, style }: InputSwitchProps) {
    return (
        <label className={'checkbox _switch' + (value ? ' checkbox-checked' : '')} style={style}>
            <input type="checkbox" checked={value} disabled={disabled} onChange={(e) => {
                onChange && onChange(e.target.checked);
            }} /> {label}
            <i>
            </i>
        </label>
    );
}